import {
  OEText,
  LinkButton,
  WinkEmojiDivider,
} from '@openeducation/oe-it-components';
import { getTimeFromDate } from '@openeducation/oe-it-services';
import { CurrentClass } from '@openeducation/oe-it-shared-types';
import { styled } from '@openeducation/oe-it-themes';
import { useState } from 'react';
import { DataTable } from 'react-native-paper';

import { Card } from '../../atoms/card/card';
import { useRole } from '../../hooks/use-role';
import { BoxMessage } from '../../molecules/box-message/box-message';
import {
  ClassStudentsModal,
  type StudentListItem,
} from '../class-students-modal/class-students-modal';

export interface CurrentClassCardProps {
  currentClass?: CurrentClass;
  teacherName: string;
}
export const CurrentClassCard = ({
  currentClass,
  teacherName,
}: CurrentClassCardProps) => {
  const { isTeacher } = useRole();
  const [students, setStudents] = useState<StudentListItem[]>([]);

  const showStudentList = () => {
    if (currentClass && currentClass?.attendees?.length > 0) {
      setStudents(
        currentClass?.attendees?.filter(
          (attendee) => attendee.name !== teacherName
        )
      );
    }
  };

  const startTime = currentClass?.classBegin
    ? getTimeFromDate(currentClass?.classBegin)
    : '';

  if (!isTeacher) {
    return null;
  }
  return (
    <>
      <Card title="Active Class" fullWidth>
        {currentClass ? (
          <DataTable>
            <DataTable.Header>
              <CellHeader flex={0.75}>
                <OEText fontType="bold">Classroom ID</OEText>
              </CellHeader>
              <CellHeader flex={0.5}>
                <OEText fontType="bold">Start</OEText>
              </CellHeader>
              <CellHeader flex={2}>
                <OEText fontType="bold">Title</OEText>
              </CellHeader>
              <CellHeader flex={0.5}>
                <OEText fontType="bold">Lang</OEText>
              </CellHeader>
              <CellHeader flex={0.5}>
                <OEText fontType="bold">Duration</OEText>
              </CellHeader>
              <CellHeader flex={1.5}>
                <OEText fontType="bold">Level</OEText>
              </CellHeader>
              <CellHeader>
                <OEText fontType="bold">Student List</OEText>
              </CellHeader>
            </DataTable.Header>
            <DataTable.Row>
              <Cell flex={0.75}>
                <OEText>{currentClass.classroomId}</OEText>
              </Cell>
              <Cell flex={0.5}>
                <OEText>{startTime}</OEText>
              </Cell>
              <Cell flex={2}>
                <OEText>{currentClass.title}</OEText>
              </Cell>
              <Cell flex={0.5}>
                <OEText>{currentClass.languageCode}</OEText>
              </Cell>
              <Cell flex={0.5}>
                <OEText>{currentClass.duration}</OEText>
              </Cell>
              <Cell flex={1.5}>
                <OEText>{currentClass.levelCategoryName}</OEText>
              </Cell>
              <Cell>
                <LinkButton text="View" onPress={showStudentList} />
              </Cell>
            </DataTable.Row>
          </DataTable>
        ) : (
          <BoxMessage
            title="No current class"
            divider={<WinkEmojiDivider />}
            width="100%"
            padding={0}
          />
        )}
      </Card>
      <ClassStudentsModal onClose={() => setStudents([])} students={students} />
    </>
  );
};
type CellFlex = {
  flex?: number;
};
const TableHeader = styled(DataTable.Title)`
  padding-horizontal: 4px;
  cursor: pointer;
`;

const Cell = styled(DataTable.Cell)<CellFlex>`
  padding: 4px;
  flex: ${({ flex }) => flex ?? 1};
  text-align: center;
`;

const CellHeader = styled(TableHeader)<CellFlex>`
  flex: ${({ flex }) => flex ?? 1};
`;
